<p-card styleClass="very-compact-card p-3">
  <div class="flex align-items-center gap-2">
    <h3 class="m-0">История</h3>
    <crm-button-show-and-hide
      [isShow]="bannerHistory.showHistory"
      (isShowChange)="isShowChange($event)"></crm-button-show-and-hide>
  </div>

  <div
    *ngIf="bannerHistory.showHistory"
    class="mt-3">
    <ng-container *ngIf="!bannerHistory.loading; else loadingTemplate">
      <div
        *ngIf="bannerHistory.items?.length; else notHistory"
        class="p-3 max-h-29rem overflow-y-auto overflow-x-hidden"
        (scroll)="onScrollEndHistory($any($event.target))">
        <p-timeline
          [value]="bannerHistory.items | orderBy: '-created:date'"
          styleClass="history-timeline mt-3">
          <ng-template
            pTemplate="content"
            let-event>
            <ng-container *ngIf="toHistory(event) as event">
              <div class="flex -mt-2 mb-4">
                <crm-user-avatar
                  *ngIf="event.user; else notUser"
                  [user]="event.user"></crm-user-avatar>
                <ng-template #notUser>
                  <crm-user-avatar [user]="{ id: -1, profile: { id: '00000000-0000-0000-0000-000000000000', name: 'ФРМ', file: null } }"></crm-user-avatar>
                </ng-template>

                <div class="w-full ml-3">
                  <div class="font-medium">
                    {{ event.user?.profile?.name || 'ФРМ' }}
                    {{ event.user?.banned || event.user?.deleted ? ' (Заблокирован)' : '' }}
                  </div>
                  <div class="text-400 text-sm">{{ event.created | date: 'dd.MM.yyyy HH:mm' }}</div>
                  <div class="mt-2">
                    <span [innerHTML]="event?.name"></span>
                    <ng-container *ngIf="event.oldValue"> c "{{ event.oldValue }}"</ng-container>
                    <ng-container *ngIf="event.newValue"> на "{{ event.newValue }}"</ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>
        </p-timeline>

        <div
          *ngIf="bannerHistory.paginationLoading"
          class="text-center">
          <p-progressSpinner
            [style]="{
              width: '50px',
              height: '50px'
            }"></p-progressSpinner>
        </div>
      </div>

      <ng-template #notHistory>
        <p class="text-xl font-medium mt-2">Нет данных</p>
      </ng-template>
    </ng-container>

    <ng-template #loadingTemplate>
      <crm-spinner
        *ngIf="bannerHistory.loading"
        top="mt-4 pb-0 mb-4 pb-4"></crm-spinner>
    </ng-template>
  </div>
</p-card>
